import { useQueryClient } from "@tanstack/react-query";

export const useDefaultQueryRetry = () => {
  const queryClient = useQueryClient();

  const globalRetry = queryClient.getDefaultOptions().queries?.retry;

  const implicitRetry = globalRetry ?? (typeof window === "undefined" /* SSR? */ ? 0 : 3);

  return (failureCount: number, error: Error) => {
    // NOTE: This is using if statements instead of a switch statement,
    // because typescript type narrowing does not work with switch statements.

    if (typeof implicitRetry === "function") {
      return implicitRetry(failureCount, error);
    }

    if (typeof implicitRetry === "number") {
      return failureCount <= implicitRetry;
    }

    return implicitRetry; // true → infinite, false → never
  };
};
